import { render, staticRenderFns } from "./duibidata.vue?vue&type=template&id=290b247b&scoped=true"
import script from "./duibidata.vue?vue&type=script&lang=js"
export * from "./duibidata.vue?vue&type=script&lang=js"
import style0 from "./duibidata.vue?vue&type=style&index=0&id=290b247b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290b247b",
  null
  
)

export default component.exports